import { useQuery, QueryResult } from '@apollo/client'
import { CompanySettingsEmployeesQuery, CompanySettingsEmployeesQueryVariables, Country } from '../../types'
import { COMPANY_SETTINGS_EMPLOYEES } from './CompanySettingsQueries'

export const useCompanySettingsEmployees = (
  companyId: string,
  employeeLevelCountry: Country = Country.All,
): QueryResult<CompanySettingsEmployeesQuery, CompanySettingsEmployeesQueryVariables> => {
  return useQuery<CompanySettingsEmployeesQuery, CompanySettingsEmployeesQueryVariables>(COMPANY_SETTINGS_EMPLOYEES, {
    variables: { companyId, employeeLevelCountry },
  })
}
